(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Read-only selected-finish guidance. Never changes variant, price or cart data. */
(() => {
  'use strict';
  const elementName = 'sg-purchase-facts';
  if (customElements.get(elementName)) return;

  class PurchaseFacts extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.controller = new AbortController();
      this.timers = [];
      this.pending = false;
      this.expectedVariant = null;
      try {
        this.config = JSON.parse(this.querySelector('[data-sg-facts-config]').textContent);
      } catch (_) { return; }
      this.finishName = this.querySelector('[data-sg-finish-name]');
      this.finishDescription = this.querySelector('[data-sg-finish-description]');
      this.section = this.closest('.shopify-section');
      if (!this.section || !this.finishName || !this.finishDescription) return;
      const options = { capture: true, signal: this.controller.signal };
      this.section.addEventListener('shopify:product:select', event => this.onProductSelect(event), options);
      // Swatch King may update the native form instead of dispatching the theme event.
      // Re-read only after interactions, including delayed app updates; no perpetual polling.
      for (const type of ['change', 'input', 'click', 'keyup']) {
        this.section.addEventListener(type, event => {
          if (!this.contains(event.target)) this.queueSync();
        }, options);
      }
      window.addEventListener('pageshow', () => this.queueSync(), { signal: this.controller.signal });
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.syncFromForm();
      });
      this.observer.observe(this.section, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['value', 'checked', 'selected', 'data-current-checked']
      });
      this.queueSync();
    }

    disconnectedCallback() { this.stop(); }

    stop() {
      this.controller?.abort();
      this.observer?.disconnect();
      for (const timer of this.timers || []) clearTimeout(timer);
      this.timers = [];
      this.sequence = (this.sequence || 0) + 1;
    }

    formVariantId() {
      const form = document.getElementById(this.dataset.formId);
      if (!form || form.tagName !== 'FORM' || !this.section.contains(form)) return null;
      const ids = Array.from(form.elements).filter(control =>
        control.form === form && control.name === 'id' && !control.disabled &&
        !['button', 'submit', 'reset', 'image'].includes(control.type) &&
        (!['radio', 'checkbox'].includes(control.type) || control.checked)
      ).map(control => String(control.value || '').trim());
      if (!ids.length || ids.some(id => !/^\d+$/.test(id)) || new Set(ids).size !== 1) return null;
      return ids[0];
    }

    queueSync() {
      for (const timer of this.timers) clearTimeout(timer);
      this.timers = [0, 100, 400, 1200, 3000].map(delay => setTimeout(() => this.syncFromForm(), delay));
    }

    syncFromForm() {
      if (this.pending) return;
      const id = this.formVariantId();
      if (this.expectedVariant && id !== this.expectedVariant) return;
      this.expectedVariant = null;
      this.renderVariant(id);
    }

    renderVariant(id) {
      const identity = this.querySelector('[data-sg-method-identity]');
      const method = this.config.methods?.[id];
      if (identity) {
        const text = method === 'Hand-Painted'
          ? 'Hand-painted · Artist-grade linen canvas · Layered paint'
          : method === '3D Printed'
            ? 'Layered 3D printing · Linen canvas · Raised texture'
            : 'Choose an available production method, size and finish.';
        if (identity.textContent !== text) identity.textContent = text;
      }
      const finish = this.config.variants[id];
      const description = this.config.finishes[finish];
      const name = description ? finish : this.config.unresolvedName;
      const body = description || this.config.unresolvedDescription;
      if (this.finishName.textContent !== name) this.finishName.textContent = name;
      if (this.finishDescription.textContent !== body) this.finishDescription.textContent = body;
      if (description) this.dataset.variantId = id;
      else delete this.dataset.variantId;
    }

    onProductSelect(event) {
      const target = event.target;
      if (!target?.closest || target.closest('product-card') || target.closest('.shopify-section') !== this.section) return;
      const context = target.closest('[data-product-id]');
      if (context && context.dataset.productId !== this.dataset.productId) return;
      const sequence = ++this.sequence;
      this.pending = true;
      this.expectedVariant = null;
      this.renderVariant(null);
      if (!event.promise?.then) {
        this.pending = false;
        this.queueSync();
        return;
      }
      Promise.resolve(event.promise).then(result => {
        if (sequence !== this.sequence || !this.isConnected) return;
        this.pending = false;
        const detail = result?.detail;
        const id = detail?.resource?.id != null ? String(detail.resource.id) : null;
        if (String(detail?.productId || '') !== this.dataset.productId || !this.config.variants[id]) {
          this.renderVariant(null);
          return;
        }
        this.expectedVariant = id;
        // The promise resolves the actual selected variant, even if the form's
        // own listener has not yet updated its hidden input in this microtask.
        this.renderVariant(id);
        this.queueSync();
      }).catch(() => {
        if (sequence !== this.sequence || !this.isConnected) return;
        this.pending = false;
        this.renderVariant(null);
      });
    }
  }

  customElements.define(elementName, PurchaseFacts);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    /* Genuine variant links; the Shopify form remains the source of truth. */
(() => {
  'use strict';
  const name = 'sg-production-method';
  if (customElements.get(name)) return;
  class ProductionMethod extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.controller = new AbortController();
      this.pending = false;
      this.failed = false;
      this.expectedVariant = null;
      this.timers = [];
      try {
        this.config = JSON.parse(this.querySelector('[data-sg-method-config]').textContent);
      } catch (_) { return; }
      this.section = this.closest('.shopify-section');
      this.links = [...this.querySelectorAll('[data-method]')];
      if (!this.section || !this.links.length) return;
      const options = {capture: true, signal: this.controller.signal};
      this.section.addEventListener('shopify:product:select', event => this.select(event), options);
      for (const type of ['input', 'change', 'click', 'keyup']) {
        this.section.addEventListener(type, event => {
          if (!this.contains(event.target)) this.queueSync();
        }, options);
      }
      for (const link of this.links) {
        for (const type of ['pointerdown', 'focus', 'click', 'auxclick']) {
          link.addEventListener(type, event => {
            this.sync();
            if (link.getAttribute('aria-disabled') === 'true') event.preventDefault();
          }, options);
        }
      }
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.section, {subtree:true, childList:true, attributes:true,
        attributeFilter:['value', 'checked', 'selected']});
      this.queueSync();
    }
    disconnectedCallback() { this.stop(); }
    stop() {
      this.controller?.abort();
      this.observer?.disconnect();
      for (const timer of this.timers || []) clearTimeout(timer);
      this.timers = [];
      this.sequence = (this.sequence || 0) + 1;
    }
    formId() {
      const form = document.getElementById(this.dataset.formId);
      if (!form || form.tagName !== 'FORM' || !this.section.contains(form)) return null;
      const ids = [...form.elements].filter(control =>
        control.form === form && control.name === 'id' && !control.disabled &&
        !['button','submit','reset','image'].includes(control.type) &&
        (!['radio','checkbox'].includes(control.type) || control.checked)
      ).map(control => String(control.value || ''));
      return ids.length && ids.every(id => /^\d+$/.test(id)) && new Set(ids).size === 1 ? ids[0] : null;
    }
    queueSync() {
      for (const timer of this.timers) clearTimeout(timer);
      this.timers = [0,100,400,1200,3000].map(delay => setTimeout(() => this.sync(), delay));
    }
    sync() {
      const id = this.formId();
      const selected = this.config.variants.find(variant => variant.id === id);
      const ready = !this.pending && !this.failed && selected &&
        (!this.expectedVariant || this.expectedVariant === id);
      if (ready) this.expectedVariant = null;
      for (const link of this.links) {
        const counterpart = ready && this.config.variants.find(variant =>
          variant.options[this.config.methodIndex] === link.dataset.method &&
          variant.options.every((value, index) =>
            index === this.config.methodIndex || value === selected.options[index]));
        if (counterpart?.available) {
          const url = new URL(this.config.productUrl, window.location.origin);
          url.searchParams.set('variant', counterpart.id);
          link.href = url.href;
          link.removeAttribute('aria-disabled');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled','true');
        }
        if (ready && selected.options[this.config.methodIndex] === link.dataset.method) {
          link.setAttribute('aria-current','true');
        } else link.removeAttribute('aria-current');
      }
    }
    select(event) {
      const target = event.target;
      if (!target?.closest || target.closest('product-card') ||
          target.closest('.shopify-section') !== this.section) return;
      const context = target.closest('[data-product-id]');
      if (context && context.dataset.productId !== this.dataset.productId) return;
      const sequence = ++this.sequence;
      this.pending = true;
      this.failed = false;
      this.expectedVariant = null;
      this.sync();
      if (!event.promise?.then) {
        this.pending = false;
        this.failed = true;
        this.sync();
        return;
      }
      Promise.resolve(event.promise).then(result => {
        if (sequence !== this.sequence || !this.isConnected) return;
        const detail = result?.detail;
        const id = String(detail?.resource?.id || '');
        this.pending = false;
        this.failed = String(detail?.productId || '') !== this.dataset.productId ||
          !this.config.variants.some(variant => variant.id === id);
        this.expectedVariant = this.failed ? null : id;
        this.queueSync();
      }).catch(() => {
        if (sequence !== this.sequence || !this.isConnected) return;
        this.pending = false;
        this.failed = true;
        this.sync();
      });
    }
  }
  customElements.define(name, ProductionMethod);
})();
  } catch(e) { console.error(e); }
})();

})();
